import React, { useState, useEffect } from 'react';
import { Menu, X } from 'lucide-react';
import cloudimaColorIcon from '../assets/images/cloudima.png';
import cloudimaWhiteIcon from '../assets/images/cloudima_white.png';


const Navbar = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  // Handle scroll
  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 10) {
        setIsScrolled(true);
      } else {
        setIsScrolled(false);
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  // Handle resize
  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth > 768) {
        setIsMobileMenuOpen(false);
      }
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'py-2 bg-white/80 backdrop-blur-md shadow-sm' : 'py-2 bg-transparent'}`}>
      <div className="container px-4 md:px-6 mx-auto">
        <div className="flex items-center justify-between">
          {/* Logo */}
          {
            isScrolled ? (
              <a href="/" className="flex items-center gap-2 text-cloudima-black">
                <img src={cloudimaColorIcon} className="w-50 h-6" alt="Cloudima Logo" />
              </a>
            ) : (
              <a href="/" className="flex items-center gap-2">
                <img src={cloudimaWhiteIcon} className="w-50 h-6" alt="Cloudima Logo" />
              </a>
            )
          }

          {/* Desktop Navigation */}
          <nav className={`hidden md:flex items-center space-x-8 ${isScrolled ? 'text-cloudima-darkGrey' : 'text-white'}`}>
            <a href="/#workflow" className="hover:text-cloudima-blue transition-colors duration-200 fancy-underline">Workflow</a>
            <a href="/#features" className="hover:text-cloudima-blue transition-colors duration-200 fancy-underline">Features</a>
            <a href="/about" className="hover:text-cloudima-blue transition-colors duration-200 fancy-underline">About</a>
            {/*<a href="/#testimonials" className="hover:text-cloudima-blue transition-colors duration-200 fancy-underline">Testimonials</a>*/}
            {/* <a href="/pricing" className="hover:text-cloudima-blue transition-colors duration-200 fancy-underline">Pricing</a> */}
          </nav>

          {/* CTA Buttons */}


          <div className="hidden md:flex items-center space-x-4">
            <a href="#contact" className="btn-primary text-sm py-2">
              Start For Free
            </a>
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className="md:hidden text-cloudima-darkGrey hover:text-cloudima-blue p-2 rounded-md"
            aria-label="Toggle menu"
          >
            {isMobileMenuOpen ? (
              <X size={24} />
            ) : (
              <Menu size={24} />
            )}
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      <div className={`
        md:hidden fixed inset-x-0 top-[57px] bg-white/95 backdrop-blur-md transition-all duration-300 ease-in-out
        ${isMobileMenuOpen ? 'opacity-100 translate-y-0 shadow-md' : 'opacity-0 -translate-y-8 pointer-events-none'}
      `}>
        <div className="container px-4 py-6 mx-auto space-y-4">
          <nav className="flex flex-col space-y-4">
            <a
              href="/#workflow"
              className="text-cloudima-darkGrey hover:text-cloudima-blue px-4 py-2 rounded-md transition-colors duration-200"
              onClick={() => setIsMobileMenuOpen(false)}
            >
              Workflow
            </a>
            <a
              href="/#features"
              className="text-cloudima-darkGrey hover:text-cloudima-blue px-4 py-2 rounded-md transition-colors duration-200"
              onClick={() => setIsMobileMenuOpen(false)}
            >
              Features
            </a>
            <a
              href="/about"
              className="text-cloudima-darkGrey hover:text-cloudima-blue px-4 py-2 rounded-md transition-colors duration-200"
              onClick={() => setIsMobileMenuOpen(false)}
            >
              About
            </a>

            {/*<a
              href="#testimonials"
              className="text-cloudima-darkGrey hover:text-cloudima-blue px-4 py-2 rounded-md transition-colors duration-200"
              onClick={() => setIsMobileMenuOpen(false)}
            >
              Testimonials
            </a>*/}
            {/*<a
              href="#pricing"
              className="text-cloudima-darkGrey hover:text-cloudima-blue px-4 py-2 rounded-md transition-colors duration-200"
              onClick={() => setIsMobileMenuOpen(false)}
            >
              Pricing
            </a>*/}
          </nav>
          <div className="flex flex-col space-y-3 pt-3 border-t border-gray-100">
            <a
              href="#contact"
              className="btn-primary mx-4"
              onClick={() => setIsMobileMenuOpen(false)}
            >
              Start For Free
            </a>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Navbar;